import { useEffect, useState } from "react";
import { Check } from "lucide-react";

const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export const ColorField = ({ label, value, onChange, presets, testPrefix }) => {
  const [draft, setDraft] = useState(value);
  useEffect(() => { setDraft(value); }, [value]);

  const onHex = (v) => {
    let s = v.trim();
    if (s && !s.startsWith("#")) s = `#${s}`;
    setDraft(s.toUpperCase());
    if (HEX_RE.test(s)) onChange(s.toUpperCase());
  };

  return (
    <div className="space-y-3" data-testid={`${testPrefix}-field`}>
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-[#3A322B]">{label}</span>
        <span className="font-mono text-xs text-[#9A8C7D]" data-testid={`${testPrefix}-current-hex`}>{value}</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {presets.map((p) => (
          <button key={p.hex} type="button" title={`${p.name} ${p.hex}`} onClick={() => onChange(p.hex)}
            data-testid={`${testPrefix}-preset-${p.hex.slice(1)}`}
            className="swatch" style={{ background: p.hex }}>
            {value.toUpperCase() === p.hex.toUpperCase() && <Check size={14} className="mix-blend-difference text-white" />}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-3">
        <label className="relative w-11 h-11 rounded-full overflow-hidden border border-[#CDC0B0] cursor-pointer shrink-0" style={{ background: value }}>
          <input type="color" value={value} onChange={(e) => onChange(e.target.value.toUpperCase())}
            className="absolute inset-0 opacity-0 cursor-pointer" data-testid={`${testPrefix}-native-picker`} />
        </label>
        <div className="flex-1 flex items-center border border-[#CDC0B0] rounded-full bg-white px-4 h-11 focus-within:border-[#7B5338] transition-colors">
          <span className="font-mono text-xs text-[#9A8C7D] mr-2">HEX</span>
          <input value={draft} maxLength={7} onChange={(e) => onHex(e.target.value)}
            className={`font-mono text-sm uppercase tracking-wider bg-transparent outline-none w-full ${HEX_RE.test(draft) ? "text-[#3A322B]" : "text-red-600"}`}
            data-testid={`${testPrefix}-hex-input`} />
        </div>
      </div>
    </div>
  );
};
